document.addEventListener('DOMContentLoaded', initScrollSnap);

export function initScrollSnap() {
  if (!document.body.classList.contains('enable-snap-animation')) {
    return;
  }

  const main = document.querySelector('main');
  if (!main) {
    return;
  }

  const mainContainer = main.parentElement;
  const rootContainer = getRootContainer(mainContainer);
  const nonStickyHeader = document.querySelector('meta[name="nonStickyHeader"]');
  const isStickyHeader = nonStickyHeader?.content === 'false';
  const headerContainer = document.querySelector('.headerContainer');

  if (rootContainer) {
    rootContainer.classList.add('snap-container-y-mandatory');
    rootContainer.classList.add('vh-100');
    if (isStickyHeader && headerContainer) {
      const setScrollPadding = () => {
        setTimeout(() => {
          rootContainer.style.scrollPadding = `${headerContainer.offsetHeight}px`;
        }, 0);
      };
      if (window.location.search.includes('wcmmode')) {
        const waitForHeaderToLoad = async () => {
          const xfContainer = headerContainer.querySelector('.xf-container');
          if (!xfContainer) {
            return;
          }
          while (!xfContainer.childNodes.length) {
            await new Promise((resolve) => setTimeout(resolve, 500));
          }
        };
        waitForHeaderToLoad().then(() => {
          setScrollPadding();
        });
      } else {
        setScrollPadding();
      }
    }
  }

  Array.from(mainContainer.children).forEach((element) => {
    if (element.nodeName === 'MAIN') {
      const mainScrollSnapContainer = element.querySelector('.mainScrollSnapContainer');
      if (mainScrollSnapContainer && mainScrollSnapContainer.children.length > 0) {
        Array.from(mainScrollSnapContainer.children).forEach((child) => addSnapSectionClasses(child));
      }
    } else if (element.classList.contains('experiencefragment') || element.querySelector('.experiencefragment')) {
      addSnapSectionClasses(element);
    }
  });
}

function getRootContainer(element) {
  let current = element;
  let lastMatching = null;

  while (current && current.parentElement && current.parentElement.tagName !== 'BODY') {
    if (current.classList && current.classList.contains('ss-container')) {
      lastMatching = current;
    }
    current = current.parentElement;
  }

  return lastMatching;
}

function addSnapSectionClasses(element) {
  element.classList.add('snap-align-start');
  element.classList.add('snap-stop-normal');
}
